module.exports = __webpack_public_path__ + "img/lianJ.ff7b1eb5.svg";